// The CLOSED set of fonts the rich-text editor may apply, shared by the
// editor (which authors the mark) and the render-sink sanitizer (which
// decides whether the mark survives).
//
// WHY A CLASS AND NOT INLINE STYLE (load-bearing -- do not "simplify"):
// `style` is VALUE-CONSTRAINED to `text-align: left|center|right` on BOTH
// sanitizers (frontend sanitizeHtml.js, backend rich_text_sanitizer.py) as
// deliberate CSS-injection defense. A `font-family` in a style attribute is
// dropped by design, and loosening that would reopen the injection surface
// for every CSS property. So the font picker emits a CLASS mark --
// `<span class="rte-font-<name>">` -- and OUR css (design-system/
// colors_and_type.css) owns the actual family declaration. Both sanitizers
// allow ONLY the members of this closed set, all-or-nothing per attribute.
//
// The families are self-hosted woff2 (assets/fonts/) -- no CDN, so a content
// blocker cannot strip them and there is no cross-origin font fetch. Adding a
// family means: vendor the woff2 + OFL, add the @font-face and .rte-font-*
// rule to colors_and_type.css, add the entry here, and add a row to
// DEPENDENCIES.md. The sanitizer allowlists both derive from this list, so
// they cannot drift apart.

/**
 * Ordered picker options. `value` is the class-name SUFFIX (the emitted class
 * is `rte-font-${value}`); `label` is what the distributor sees.
 */
export const RTE_FONTS = [
  { value: "poppins", label: "Poppins" },
  { value: "inter", label: "Inter" },
  { value: "lora", label: "Lora" },
  { value: "playfair", label: "Playfair Display" },
  { value: "oswald", label: "Oswald" },
  { value: "roboto-mono", label: "Roboto Mono" },
];

/** The class-name prefix every font mark carries. */
export const RTE_FONT_CLASS_PREFIX = "rte-font-";

/**
 * The closed allowlist of emitted class names. A frozen Set so a caller
 * cannot widen the boundary at runtime.
 * @type {ReadonlySet<string>}
 */
export const RTE_FONT_CLASSES = Object.freeze(
  new Set(RTE_FONTS.map((f) => `${RTE_FONT_CLASS_PREFIX}${f.value}`))
);

/**
 * True iff `token` is exactly one of the approved font classes.
 * @param {string} token - a single class token (no whitespace)
 * @returns {boolean}
 */
export function isFontClass(token) {
  return RTE_FONT_CLASSES.has(token);
}

export default RTE_FONTS;
